import React from 'react';
import ReactDOM from 'react-dom/client';
import '@sagano/auth/styles/index.css';
import '@linktivity/link-styles';
import '@sagano/auth/i18n';
import App from '@sagano/auth/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
